var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.Container,{staticClass:"skeleton"},[_c(_setup.ContentLoader,{attrs:{"viewBox":"0 0 311 82","speed":2,"primaryColor":"#f3f3f3","secondaryColor":"#ecebeb"}},[_c('rect',{attrs:{"x":"0","y":"0","rx":"0","ry":"","width":"311","height":"82"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }